var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"type":_vm.type,"primary":_vm.primary},on:{"click":function($event){return _vm.$emit("click")}}},[_c('span',{attrs:{"tabindex":"-1"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }